import noop from 'lodash/noop'
import { createContext } from 'react'

export default createContext({
  checkboxes: {},
  setCheckboxes: noop,
  tenantPaymentMethodSelection: '',
  setTenantPaymentMethodSelection: noop,
  agreePad: false,
  authPad: false,
  setAuthPad: noop,
  setAgreePad: noop
})
